import Swiper from "swiper/bundle";
import { productSpecsComponent } from './components/product-specs-pdp';
import './components/shop-the-look';
import './components/sticky-bar-product';

const swiperContainer = document.querySelector('.shop-the-look__swiper');
const swiper = new Swiper(swiperContainer, {
  direction: 'horizontal',
  slidesPerView: "auto",
  mousewheel: true,
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
    draggable: true,
  },
});

const productItems = document.querySelectorAll('.product-item__options');

productItems.forEach(item => {
  const disableSwiper = () => {
    swiper.allowTouchMove = false;
    swiper.mousewheel.disable();
  };

  const enableSwiper = () => {
    swiper.allowTouchMove = true;
    swiper.mousewheel.enable();
  };

  item.addEventListener('mouseenter', disableSwiper);
  item.addEventListener('mouseleave', enableSwiper);
  item.addEventListener('touchstart', disableSwiper);
  item.addEventListener('touchend', enableSwiper);
});

document.addEventListener('DOMContentLoaded', async() => {
  productSpecsComponent();
});
